import React, { useState } from "react";
import { createPortal } from "react-dom";
import { Icon } from "@iconify/react";
import "./IconButton.scss";

const IconButton = ({
  variant,
  icon,
  onClick,
  disabled,
  className,
  title,
  type,
}) => {
  const [tooltip, setTooltip] = useState({ show: false, x: 0, y: 0 });

  const handleMouseMove = (e) => {
    // clientX/Y gives us coordinates relative to the screen (viewport)
    // We add an offset (10px) so the tooltip doesn't overlap the mouse pointer
    setTooltip({
      show: true,
      x: e.clientX + 12,
      y: e.clientY + 12,
    });
  };

  const handleMouseLeave = () => {
    setTooltip((prev) => ({ ...prev, show: false }));
  };

  // Combine classes
  const buttonClass =
    `icon-button icon-button--${variant} ${className || ""}`.trim();

  return (
    <>
      <button
        className={buttonClass}
        onClick={onClick}
        disabled={disabled}
        // These events track the mouse
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        // Use aria-label for accessibility, but remove title to prevent default browser tooltip
        aria-label={title}
        type={type}
      >
        <Icon icon={icon} />
      </button>

      {tooltip.show &&
        title &&
        createPortal(
          <div
            className="custom-mouse-tooltip"
            style={{
              top: tooltip.y,
              left: tooltip.x,
            }}
          >
            {title}
          </div>,
          document.body,
        )}
    </>
  );
};

export default IconButton;
